import Swiper from 'swiper/bundle';

export default function blockImageSlider() {
  document.querySelectorAll('.image-slider:not(.image-slider--disabled)').forEach(function (slider) {


    const swiper = new Swiper(slider, {
      speed: 1000,
      loop: false,
      parallax: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },

      // navigation: {
      //   nextEl: slider.querySelector('.slider__arrow--next'),
      //   prevEl: slider.querySelector('.slider__arrow--prev'),
      // },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
      },


      on: {
        init: (e) => {
          const activeSlide = e.slides[e.activeIndex];
          activeSlide.querySelector('.image-slider__image').classList.add('image-slider__image--active');
          console.log('init');
          // activeSlide.querySelectorAll('.block-home-slider__title__item').forEach((el) => {
          //   el.classList.add('block-home-slider__title__item--animate');
          // });
        },
        slideChange: (e) => {
          console.log('change');
          const activeIndex = e.activeIndex;

          e.slides.forEach((slide, index) => {
            const item = slide.querySelector('.image-slider__image');
            // const titleItems = slide.querySelectorAll('.block-home-slider__title__item');

            if (slide === e.slides[activeIndex]) {
              item.classList.add('image-slider__image--active');

            } else {

              setTimeout(() => {
                item.classList.remove('image-slider__image--active');
              }, "1000");
            }
          });


        },
      },

    });



  });
}